<div [style.width]="width+unit" [style.height]="height+unit" class="icon-wrapper icon-{{icon}}"></div>
